import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconFileListBan: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 16.875H5C3.68583 16.875 3.125 16.3142 3.125 15V5C3.125 3.68583 3.68583 3.125 5 3.125H9.375V5C9.375 7.015 10.485 8.125 12.5 8.125H14.375V10C14.375 10.345 14.655 10.625 15 10.625C15.345 10.625 15.625 10.345 15.625 10V7.5C15.625 7.33417 15.5592 7.175 15.4417 7.05833L10.4417 2.05833C10.3242 1.94083 10.1658 1.875 10 1.875H5C2.985 1.875 1.875 2.985 1.875 5V15C1.875 17.015 2.985 18.125 5 18.125H10C10.345 18.125 10.625 17.845 10.625 17.5C10.625 17.155 10.345 16.875 10 16.875ZM10.625 5V4.00917L13.4908 6.875H12.5C11.1858 6.875 10.625 6.31417 10.625 5ZM6.45833 10C6.45833 10.345 6.17833 10.625 5.83333 10.625C5.48833 10.625 5.20833 10.345 5.20833 10C5.20833 9.655 5.48833 9.375 5.83333 9.375C6.17833 9.375 6.45833 9.655 6.45833 10ZM6.45833 13.3333C6.45833 13.6783 6.17833 13.9583 5.83333 13.9583C5.48833 13.9583 5.20833 13.6783 5.20833 13.3333C5.20833 12.9883 5.48833 12.7083 5.83333 12.7083C6.17833 12.7083 6.45833 12.9883 6.45833 13.3333ZM11.6667 10.625H7.91667C7.57167 10.625 7.29167 10.345 7.29167 10C7.29167 9.655 7.57167 9.375 7.91667 9.375H11.6667C12.0117 9.375 12.2917 9.655 12.2917 10C12.2917 10.345 12.0117 10.625 11.6667 10.625ZM7.91667 13.9583C7.57167 13.9583 7.29167 13.6783 7.29167 13.3333C7.29167 12.9883 7.57167 12.7083 7.91667 12.7083H9.16667C9.51167 12.7083 9.79167 12.9883 9.79167 13.3333C9.79167 13.6783 9.51167 13.9583 9.16667 13.9583H7.91667ZM15.4167 11.875C13.4633 11.875 11.875 13.4633 11.875 15.4167C11.875 17.37 13.4633 18.9583 15.4167 18.9583C17.37 18.9583 18.9583 17.37 18.9583 15.4167C18.9583 13.4633 17.37 11.875 15.4167 11.875ZM15.4167 13.125C15.8208 13.125 16.1959 13.2392 16.5259 13.4233L13.4241 16.5258C13.2399 16.1958 13.125 15.8208 13.125 15.4167C13.125 14.1533 14.1525 13.125 15.4167 13.125ZM15.4167 17.7083C15.0125 17.7083 14.6375 17.5942 14.3075 17.41L17.4093 14.3075C17.5934 14.6375 17.7083 15.0125 17.7083 15.4167C17.7083 16.68 16.6808 17.7083 15.4167 17.7083Z"
      fill={color}
    />
  </svg>
);

export default IconFileListBan;
